import { isValid } from 'date-fns';
import { Observable, of } from 'rxjs';
import { mapTo, tap } from 'rxjs/operators';

import { catchErrorLogRet } from '../../../common/rest.operators';
import { CacheMetricParams } from '../../../insight/performance-data/cache-metric-params.pd.model';
import { CacheMetric } from '../../../insight/performance-data/cache-metric.pd.model';
import { PerformanceDataViewType } from '../../../insight/performance-data/metric.pd.model';
import { PerformanceDataService } from '../../../insight/performance-data/performance-data.service';
import { epicDependencies } from '../../../store';
import { SELECTED_ITEM_ALL_ID } from '../../../user/population-select';
import { DataDimension, ReportType } from '../../backend';
import { currentBuilderState } from '../builder.state';

import { filterMetrics } from './filter-metrics.function';

export function loadCacheMetrics(): Observable<void> {
    const performanceDataService =
        epicDependencies.injector.get<PerformanceDataService>(
            PerformanceDataService,
        );

    const state = currentBuilderState();
    const vp = state.viewParams;

    const cmParams: CacheMetricParams = {};

    if (vp.periodType?.id != null) {
        cmParams.periodTypeId = vp.periodType.id;
    }

    if (isValid(vp.cacheDate?.endDate)) {
        cmParams.eventDate = vp.cacheDate.endDate;
    }

    switch (vp.reportType) {
        case ReportType.Role:
            if (vp.role?.[0]?.id != null) {
                cmParams.roleIds = [vp.role[0].id];
            }

            if (
                vp.site?.[0]?.id != null &&
                vp.site?.[0]?.id !== SELECTED_ITEM_ALL_ID
            ) {
                cmParams.siteIds = [vp.site[0].id];
            }

            switch (vp.dataDimension) {
                case DataDimension.SuperGroup:
                    cmParams.dataViewTypeId =
                        PerformanceDataViewType.USER_SUPER_GROUP;

                    if (vp.superGroup?.[0]?.id != null) {
                        cmParams.superGroupIds = [vp.superGroup[0].id];
                    }

                    break;
                case DataDimension.Queue:
                    cmParams.dataViewTypeId =
                        PerformanceDataViewType.USER_QUEUE;

                    if (
                        vp.queue?.[0]?.id != null &&
                        vp.queue?.[0]?.id !== SELECTED_ITEM_ALL_ID
                    ) {
                        cmParams.queueIds = [vp.queue[0].id];
                    }

                    break;
            }

            break;
        case ReportType.Team:
            cmParams.dataViewTypeId = PerformanceDataViewType.USER_QUEUE;

            if (vp.team?.[0]?.id != null) {
                cmParams.managerIds = [vp.team[0].id];
            }

            if (
                vp.queue?.[0]?.id != null &&
                vp.queue?.[0]?.id !== SELECTED_ITEM_ALL_ID
            ) {
                cmParams.queueIds = [vp.queue[0].id];
            }

            break;
        case ReportType.Individual:
            cmParams.dataViewTypeId = PerformanceDataViewType.USER_QUEUE;

            if (vp.individual?.[0]?.id != null) {
                cmParams.userIds = [vp.individual[0].id];
            }

            if (
                vp.queue?.[0]?.id != null &&
                vp.queue?.[0]?.id !== SELECTED_ITEM_ALL_ID
            ) {
                cmParams.queueIds = [vp.queue[0].id];
            }

            break;
    }

    if (
        cmParams.dataViewTypeId == null ||
        cmParams.periodTypeId == null ||
        cmParams.eventDate == null
    ) {
        return of(null);
    }

    return performanceDataService.listCacheMetrics(cmParams).pipe(
        catchErrorLogRet([]),
        tap((ret) => {
            _loadCacheMetrics(ret);
        }),
        mapTo(null),
    );
}

function _loadCacheMetrics(ret: CacheMetric[]): void {
    const state = currentBuilderState();

    ret.forEach((cm) => {
        cm.fullName = (cm.fullName ?? '').trim();
    });
    ret.sort((a, b) => a.fullName.localeCompare(b.fullName));

    state.metrics = ret?.map((cm) => {
        return {
            id: cm.metricId,
            fullName: cm.fullName,
            shortName: cm.shortName,
            initials: cm.initials,
        };
    });

    filterMetrics();
}
